import React, { useState } from 'react';
import type { ReactNode } from 'react';
import type { Organization } from '../types';
import { apiService } from '../utils/api';
import { AuthContext } from './AuthContext';

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [email, setEmail] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [organizations, setOrganizations] = useState<Organization[]>([]);

  // Restore authentication state on app startup
  React.useEffect(() => {
    const savedToken = localStorage.getItem('customer_portal_token');
    const savedEmail = localStorage.getItem('customer_portal_email');
    if (savedToken && savedEmail) {
      setToken(savedToken);
      setEmail(savedEmail);

      // Fetch fresh organization data
      apiService
        .getOrganizationsByEmail(savedEmail)
        .then((orgs) => {
          setOrganizations(orgs);
        })
        .catch((err) => {
          console.error('Failed to restore organizations:', err);
        });
    }
  }, []);

  const login = (email: string, token: string) => {
    setEmail(email);
    setToken(token);
    localStorage.setItem('customer_portal_token', token);
    localStorage.setItem('customer_portal_email', email);
  };

  const logout = () => {
    setEmail(null);
    setToken(null);
    setOrganizations([]);
    localStorage.removeItem('customer_portal_token');
    localStorage.removeItem('customer_portal_email');
  };

  return (
    <AuthContext.Provider
      value={{
        email,
        token,
        organizations,
        isAuthenticated: !!email,
        login,
        logout,
        setOrganizations,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
